import React, { Component } from 'react';
import './sideMenu.css'
import Logo from '../../../Assets/images/Logo.png'
import String from '../../../Assets/locals'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

class SideMenu extends Component {
  render() {
    String.setLanguage(this.props.lang);
    let menu = []
    if (this.props.screenType === 'MAGAZINE') {
      menu = [{ path: "/Aboutus", title: String.vice }, { path: "/Magazin", title: String.vision }, { path: "/Magazin", title: String.administrationMember }, { path: "/PublishRules", title: String.publicationRule },
      { path: "/Regulations", title: String.regulation }, { path: "/volumes/fullvolumes", type: 'FULL', title: String.completeIssues }, { path: "/volumes/specialvolumes", type: 'PRIVATE', title: String.privateIssues }, { path: "/Members", title: String.editorialBoard }
        , { path: "/ViewForms", title: String.forms }, { path: "/AllNews", title: String.news }, { path: "/Magazin", title: String.mailing }
      ]
    } else {
      menu = [{ path: "/Aboutus", title: String.vice }, { path: "/promotion", title: String.vision }, /*{ path: "/promotion", title: String.administrationMember }, { path: "/PublishRules", title: String.publicationRule },
      { path: "/Regulations", title: String.regulation }, { path: "/Members", title: String.editorialBoard }
       */ , { path: "/ViewForms", title: String.forms }, /*{ path: "/AllNews", title: String.news },*/ { path: "/promotion", title: String.mailing }
      ]
    }

    return (
      <div className="sidemenu" style={{
        height: "99%",
        boxShadow: this.props.lang === "ar" ? "rgb(183, 183, 183) -1px 0px 8px 1px" : "rgb(183, 183, 183) 1px 0px 8px 1px"
      }}>
        <div className="Logo text-center">
          <img src={Logo} alt="Logo" />
        </div>
        <ul className={this.props.lang === "ar" ? "ul_ar" : "ul_en"}>
          {menu.map((element, index) => {
            return (
              <li className={this.props.lang === "ar" ? "pr-4" : "pl-4"} key={index}><Link to={{ pathname: element.path, state: { volumeType: element.type } }}
                style={{ color: '#393939' }}>{element.title} </Link> </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.login.language,
    screenType: state.login.screentype

  }
}
export default connect(mapStateToProps, null)(SideMenu);